import React, { useState, useCallback, useEffect } from "react";

import Dashboard from "./pages/Dashboard";
import TicketDetail from "./pages/TicketDetail";
import { AnimatePresence } from "motion/react";
import {
  Box,
  Divider as MuiDivider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import { spacing, useTheme } from "@mui/system";
import styled from "@emotion/styled";
import { LayoutDashboard, Settings as IconSettings } from "lucide-react";
import { useParams } from "react-router-dom";
import { ticketService } from "./services/ticketService";

const Divider = styled(MuiDivider)(spacing);

//Save button nella details della richiesta

export default function SupportHub() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box>
      <Helmet title="Support Hub" />
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "start",
          gap: 4,
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h3" display="inline">
          Support Hub
        </Typography>
      </Box>
      <Divider mt={4} />
      <Box
        sx={{
          display: "flex",

          fontFamily: "Inter, sans-serif",
        }}
      >
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflowX: "hidden",
          }}
        >
          <AnimatePresence mode="wait">
            <Dashboard key="dashboard" />
          </AnimatePresence>
        </Box>
      </Box>
    </Box>
  );
}
